import { render, staticRenderFns } from "./JIndustry.vue?vue&type=template&id=2c97d274"
import script from "./JIndustry.vue?vue&type=script&lang=js"
export * from "./JIndustry.vue?vue&type=script&lang=js"
import style0 from "./JIndustry.vue?vue&type=style&index=0&id=2c97d274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports